import { Suggest } from './Suggest';
export default Suggest;
